import { render, staticRenderFns } from "./KnowledgeBaseArchives.vue?vue&type=template&id=0b8b492e&scoped=true"
import script from "./KnowledgeBaseArchives.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseArchives.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBaseArchives.vue?vue&type=style&index=0&id=0b8b492e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8b492e",
  null
  
)

export default component.exports